import { createContext, useContext, useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { MODAL_IDX } from '../utils/constant';

type ModalState = {
  modal: boolean;
  modalContent: React.ReactNode;
  handleModal: Function;
};
export const ModalContext = createContext<ModalState>({
  modal: false,
  modalContent: null,
  handleModal: () => {},
});

export const ModalContextProvider = ({ children }: { children: React.ReactNode }) => {
  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState<React.ReactNode>("I'm the Modal Content");

  const handleModal = (content = false) => {
    if (content) {
      setModalContent(content);
      setModal(true);
    } else {
      setModalContent('');
      setModal(false);
    }
  };
  const handlePopState = () => {
    if (modal) {
      setModal(false);
    }
  };

  // 컴포넌트가 마운트 될 때 이벤트 리스너 추가
  useEffect(() => {
    window.addEventListener('popstate', handlePopState);

    // 컴포넌트가 언마운트 될 때 이벤트 리스너 제거
    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [modal]); // modal의 상태 변화에 따라 effect 실행

  const value = { modal, modalContent, handleModal };

  return (
    <ModalContext.Provider value={value}>
      {<Modal /> }
      {children}
    </ModalContext.Provider>
  );
};

const Modal = () => {
  const { modalContent, modal } = useContext(ModalContext);
  if (modal && modalContent) {
    return ReactDOM.createPortal(
      <div
        className="fixed inset-0 z-[var(--modal-z,1050)] flex items-center justify-center p-4 bg-black/55 backdrop-blur-sm"
        style={{ zIndex: MODAL_IDX }}
        role="presentation"
      >
        <div className="relative flex flex-col items-center max-w-[calc(100vw-2rem)] text-left">
          {modalContent}
        </div>
      </div>,
      document.querySelector('#modal-root') as HTMLElement
    );
  } else return null;
};
